import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import '../../elements/typography/tg-label-one';
import '../../elements/typography/tg-caption';
import '../../elements/icon-badge';
import styles from './styles';
/**
 * @dependency amityeko-tg-label-one
 * @dependency amityeko-tg-caption
 * @dependency amityeko-icon-badge
 *
 * @slot badge-icon - Icon to show inside the icon badge (amityeko-icon is expected).
 */
export default class AmityekoEmptyView extends LitElement {
    constructor() {
        super(...arguments);
        this.label = undefined;
        this.caption = undefined;
    }
    render() {
        return html `
      <div>
        <amityeko-icon-badge><slot name="badge-icon"></slot></amityeko-icon-badge>
        ${this.label && html `<amityeko-tg-label-one>${this.label}</amityeko-tg-label-one>`}
        ${this.caption && html `<amityeko-tg-caption>${this.caption}</amityeko-tg-caption>`}
      </div>
    `;
    }
}
AmityekoEmptyView.styles = styles;
__decorate([
    property()
], AmityekoEmptyView.prototype, "label", void 0);
__decorate([
    property()
], AmityekoEmptyView.prototype, "caption", void 0);
if (!customElements.get('amityeko-empty-view')) {
    customElements.define('amityeko-empty-view', AmityekoEmptyView);
}
//# sourceMappingURL=index.js.map